import PaymentBtn from "./PaymentBtn";

export default PaymentBtn;